import React from 'react';
import PropTypes from 'prop-types';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { staticPageUrls } from '../../utils/consts';

const Breadcrumbs = (props) => {
  const { seperator, breadcrumbs, startFromHome } = props;
  let _breadcrumbs = [];
  if (startFromHome) {
    _breadcrumbs.push(staticPageUrls.home);
  }
  if (breadcrumbs && breadcrumbs.length > 0) {
    _breadcrumbs = [..._breadcrumbs, ...breadcrumbs];
  }

  if (!_breadcrumbs.length) return null;
  return (
    <div
      className="sui-w-full sui-overflow-x-auto sui-relative sui-whitespace-nowrap sui-inline-flex"
      data-testid="Breadcrumbs"
    >
      {_breadcrumbs.map((crumb, index) => {
        let { url, name: crumbName } = crumb;
        const isLinkableCrumb = index !== _breadcrumbs.length - 1
          || (index === _breadcrumbs.length - 1
          && _breadcrumbs[_breadcrumbs.length - 1].shouldLastCrumbBeLinkable);
        return (
          <div key={index} className="sui-mb-0">
            {isLinkableCrumb ? (
              <Link href={url} color="subtle">
                {crumbName}
              </Link>
            ) : (
              <Typography component="span" color="subtle">
                {crumbName}
              </Typography>
            )}
            {index < _breadcrumbs.length - 1 && (
              <span className="sui-px-2 sui-text-subtle sui-text-base">
                {seperator}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

Breadcrumbs.defaultProps = {
  seperator: '/',
  startFromHome: true,
};

Breadcrumbs.propTypes = {
  seperator: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(
    {
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    }
  )).isRequired,
  startFromHome: PropTypes.bool,
};

export default Breadcrumbs;
